// extracted by mini-css-extract-plugin
export default {"main":"Mission_main__h63m6","title":"Mission_title__LheAH","subtitle":"Mission_subtitle__TWeNh","container":"Mission_container__vBWt3"};